import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { ProductClass } from '../models/product-class.model';

@Injectable({
  providedIn: 'root'
})
export class ProductClassValidatorService extends ValidatorService {
  isValid(data: ProductClass) {
    this.errors = [];

    if (!this.isSupplied(data.name)) {
      this.errors.push('name');
    }

    if (!this.isSupplied(data.code)) {
      this.errors.push('code');
    }

    return this.errors.length === 0;
  }
}
